
export { gtmViewAffiliateSection } from "./gtmAffiliate"